import { Card, Row, Col, Spinner } from 'react-bootstrap';

function DashStatCard({ title, value, icon, color, subtitle, loading }) {
  return (
    <Card className="dashboard-card stat-card border-0 h-100">
      <Card.Body>
        <Row className="align-items-center">
          <Col xs={8}>
            <p className="stat-card-label mb-1">{title}</p>
            <h2 className="stat-card-value mb-0">
              {loading ? <Spinner animation="border" size="sm" /> : (value ?? '—')}
            </h2>
            {subtitle && <small className="text-muted">{subtitle}</small>}
          </Col>
          <Col xs={4} className="text-end">
            <div className={`stat-card-icon text-${color}`}>
              <i className={`bi ${icon}`}></i>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default DashStatCard;
